import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/subscription';
import { DocumentService, Documentos } from '../shared';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  moduleId: module.id,
  selector: 'bp-document-list',
  templateUrl: 'document-list.component.html'
})

export class DocumentListComponent implements OnInit, OnDestroy {

  private catId: number;
  documents: Documentos[] = [];
  
  constructor(
    private documentService: DocumentService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  private getDocuments(): void {
    this.documents = [];
    this.documentService.getDocuments(this.catId)
      .subscribe(documents => {
        this.documents = documents;
      });
  }

  ngOnInit(): void {
    this.route
      .params
      .map(params => params['id'])
      .do(id => this.catId = +id)
      .subscribe(id => {
        if (this.catId) {

          this.getDocuments();

        } else {
          //console.log('neam id', this.catId);
          //TODO: videti sta sa ovom dvojkom
          //this.router.navigateByUrl(`/documents/13`);
        }

      });
  }

  ngOnDestroy(): void {
   
  }

}



// WEBPACK FOOTER //
// ./src/app/documents/document-list/document-list.component.ts